import React from "react";

import {
  FiLock,
  FiCheckCircle,
  FiGift
} from "react-icons/fi";

const AchievementCard = ({

  achievement,

  onClaim

}) => {

  const {

    badgeId,

    title,

    description,

    icon,

    xp,

    unlocked,

    claimed

  } = achievement;

  const handleClaim = () => {

    if (

      unlocked &&

      !claimed

    ) {

      onClaim(

        badgeId

      );

    }

  };

  return (

    <div

      className={

        `achievement-card

        ${

          unlocked

            ? "unlocked"

            : "locked"

        }

        ${

          claimed

            ? "claimed"

            : ""

        }`

      }

    >

      {/* TOP */}

      <div className="achievement-top">

        <div className="achievement-icon">

          {

            icon.endsWith(".png") ||

            icon.endsWith(".svg")

            ?

            (

              <img

                src={icon}

                alt={title}

              />

            )

            :

            (

              <span>

                {icon}

              </span>

            )

          }

        </div>

      </div>

      {/* BODY */}

      <div className="achievement-body">

        <h3>

          {title}

        </h3>

        <p>

          {description}

        </p>

      </div>

      {/* XP */}

      <div className="achievement-xp">

        +{xp} XP

      </div>

      {/* FOOTER */}

      <div className="achievement-footer">

        {

          claimed ?

          (

            <div className="achievement-state claimed">

              <FiCheckCircle />

              <span>

                Claimed

              </span>

            </div>

          )

          :

          unlocked ?

          (

            <button

              className="claim-button"

              onClick={

                handleClaim

              }

            >

              <FiGift />

              Claim Reward

            </button>

          )

          :

          (

            <div className="achievement-state locked">

              <FiLock />

              <span>

                Locked

              </span>

            </div>

          )

        }

      </div>

    </div>

  );

};

export default AchievementCard;